import {AdvertState, emptyAdvert} from '@/store/modules/Advert/state';
import {MutationTree} from 'vuex';
import {Advert, AdvertType} from '#/Advert';
import {SearchOptionsMutation} from '#/Search';

export const mutations: MutationTree<AdvertState> = {
    CHANGE_FIELD_STATUS: (state: AdvertState, newStatus: boolean): void => {
        state.searchOptions.fieldOpen = newStatus;
    },
    INIT_ADVERT: (state: AdvertState): void => {
        state.advert = emptyAdvert();
    },
    INIT_SEARCH: (state: AdvertState): void => {
        state.searchOptions.results.adverts.splice(0, state.searchOptions.results.adverts.length);
    },
    EMPTY_ADVERTS: (state: AdvertState): void => {
        state.adverts.splice(0, state.adverts.length);
    },
    FAVORITE_TOGGLE: (state: AdvertState, advertId: number): void => {
        const advert = state.adverts.find(ad => ad.id === advertId);
        if (advert) {
            advert.isFavorite = !advert.isFavorite;
        }
    },
    LOAD_ADVERT: (state: AdvertState, advert: Advert): void => {
        state.advert = {...advert};
    },
    LOAD_ADVERTS: (state: AdvertState, adverts: Advert[]): void => {
        state.adverts = [...state.adverts, ...adverts];
    },
    LOAD_NEXT_PAGE: (state: AdvertState, urlNextPage: string | null): void => {
        state.urlNextPage = urlNextPage;
    },
    SAVE_PAGE_NUMBER: (state: AdvertState, pageNumber: number): void => {
        state.pageNumber = pageNumber;
    },
    SAVE_SEARCH_OPTIONS: (state: AdvertState, searchOptions: SearchOptionsMutation): void => {
        if (searchOptions.searchTerms !== null) state.searchOptions.lastTerm = searchOptions.searchTerms;
        if (searchOptions.resultNumber !== null) state.searchOptions.results.count = searchOptions.resultNumber;
        state.searchOptions.isSpecify = searchOptions.isSpecify;

        searchOptions.results.forEach(advert => {
            state.searchOptions.results.adverts.push({...advert});
        });

        if (searchOptions.facets.category !== null) {
            state.searchOptions.facets.category.splice(0, state.searchOptions.facets.category.length);
            searchOptions.facets.category.forEach(facet => {
                state.searchOptions.facets.category.push(Object.assign({}, facet));
            });
        }

        if (searchOptions.facets.type !== null) {
            state.searchOptions.facets.type.splice(0, state.searchOptions.facets.type.length);
            searchOptions.facets.type.forEach(facet => {
                state.searchOptions.facets.type.push(Object.assign({}, facet));
            });
        }

        if (searchOptions.suggests.length !== 0) {
            state.searchOptions.suggests.splice(0, state.searchOptions.suggests.length);
            searchOptions.suggests.forEach(suggest => {
                state.searchOptions.suggests.push(suggest.text);
            });
        }
    },
    SAVE_SEARCH_TERM: (state: AdvertState, searchTerm: string): void => {
        state.searchOptions.lastTerm = searchTerm;
    },
    SELECT_TYPE_FILTER: (state: AdvertState, type: AdvertType | null): void => {
        state.typeFilter = type;
    },
};
